module.exports = __webpack_public_path__ + "img/9.b7ce1162.png";